/**
 * =============================================================================
 * featureFlags.ts - Definizione Feature Flags per Multi-Tenant
 * =============================================================================
 * 
 * Definisce i feature flag disponibili nel campo `tenants.config` (JSONB).
 * Ogni tenant può abilitare/disabilitare moduli della piattaforma.
 * 
 * ARCHITETTURA:
 * - I flag sono booleani nel JSONB `tenants.config`
 * - Il tenant LNI (primo tenant) ha TUTTI i flag = true
 * - Nuovi tenant partono con TUTTI i flag = false (opt-in)
 * - Il hook `useFeatureFlag` legge i flag dal profilo/tenant corrente
 * - Il componente `FeatureGuard` nasconde UI se il flag è false
 * 
 * @version 1.0.0 - Feature Flags Phase 2
 * =============================================================================
 */

/**
 * Elenco dei feature flag supportati.
 * Ogni chiave corrisponde a un campo booleano in `tenants.config`.
 */
export type FeatureFlag =
  | "feature_quiz_engine"
  | "feature_certificates"
  | "feature_attendance"
  | "feature_financials"
  | "feature_lni_workflow"
  | "feature_live_lessons"
  | "feature_practical_outings";

/**
 * Configurazione di default per NUOVI tenant.
 * Tutti i moduli sono disabilitati di default (opt-in).
 */
export const DEFAULT_FEATURE_FLAGS: Record<FeatureFlag, boolean> = {
  feature_quiz_engine: false,
  feature_certificates: false,
  feature_attendance: false,
  feature_financials: false,
  feature_lni_workflow: false,
  feature_live_lessons: false,
  feature_practical_outings: false,
};

/**
 * Descrizioni human-readable per ogni feature flag.
 * Utili per UI admin di gestione tenant.
 */
export const FEATURE_FLAG_LABELS: Record<FeatureFlag, string> = {
  feature_quiz_engine: "Quiz ministeriali ed esercitazioni",
  feature_certificates: "Generazione attestati PDF",
  feature_attendance: "Registro presenze e QR code",
  feature_financials: "Crediti, pagamenti e fatturazione",
  feature_lni_workflow: "Workflow LNI (Preselezione → Corso → Esame)",
  feature_live_lessons: "Lezioni live (Zoom/Calendar)",
  feature_practical_outings: "Uscite pratiche certificate (timone e manovre)",
};
